<template>
  <div v-if="isNoResults">
    {{
      $t('search.searchResults.nResultsEverywhere', {
        n: hitsLength,
      })
    }}
  </div>
  <div v-else-if="filters && filters.online">
    {{
      $t('search.searchResults.nResultsOnline', {
        n: hitsLength,
      })
    }}
  </div>
  <div v-else-if="filters && filters.locality && filters.locality.name">
    {{
      $t('search.searchResults.nResultsInCity', {
        n: hitsLength,
        locality: currentLocality || filters.locality.name,
      })
    }}
  </div>
  <div v-else-if="filters.categories && filters.categories.length > 0">
    {{
      $t('search.searchResults.nResultsForCategory', {
        n: hitsLength,
        category: filters.categories[0],
      })
    }}
  </div>
  <div v-else-if="filters.searchquery">
    {{
      $t('search.searchResults.nResultsForSearchQuery', {
        n: hitsLength,
        searchQuery: filters.searchquery,
      })
    }}
  </div>
  <div v-else>
    {{
      $t('search.searchResults.nResultsEverywhere', {
        n: hitsLength,
      })
    }}
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    hitsLength: number
    filters?: { any }
    currentLocality?: string
    isNoResults?: boolean
  }>(),
  {
    hitsLength: 0,
    filters: () => ({}),
    currentLocality: '',
    isNoResults: false,
  }
)
</script>
